<template lang="pug">
  .modal.is-active
    .modal-background(@click="cerrarModal")
    .modal-content
      .box
        .subtitle {{ getTitle() }}
        .columns
          .column.is-12
            h3 {{ getContent() }}
            br
            span(v-html="getTotal()")
        .columns(v-show="verTabla")
          .column.is-12
            ul
              li(v-for="(salida) in consumible.salidas" :key="salida.id")
                .field.is-grouped.is-grouped-multiline
                  .control
                    .tags.has-addons
                      span.tag
                        | Fecha:
                      span.tag.is-primary
                        | {{ salida.fechaReg }}
                  .control
                    .tags.has-addons
                      span.tag
                        | Cantidad
                      span.tag.is-primary
                        | {{ salida.cantidad_r }}
                  .control
                    .tags.has-addons
                      span.tag
                        | Recibe:
                      span.tag.is-primary
                        | {{ salida.recibe }}
                hr.divider
        .columns(v-show="!verTabla")
          .column.is-12
            span
              | No hay existen salidas para este consumible y ubicación.
      button.modal-close.is-large.is-rounded(aria-label='close' @click.prevent="cerrarModal")
</template>

<script>
  export default {
    name: 'ModalDocumentos',
    props: {
      consumible: {
        type: Object,
        default: () => {}
      }
    },
    watch: {
      consumible() {
        if (Object.keys(this.consumible).length > 0) {
          if (this.consumible.salidas.length > 0 ) {
            this.verTabla = true
          } else {
            this.verTabla = false
          }
        } else {
          this.verTabla = false
        }
      }
    },
    data() {
      return {
        verTabla: false
      }
    },
    methods: {
      getTitle () {
        const subcat = this.consumible.subcategoria ? ` ${this.consumible.subcategoria}` : ''
        const marca = this.consumible.marca ? ` | ${this.consumible.marca}` : ''
        const modelo = this.consumible.modelo ? ` - ${this.consumible.modelo}` : ''
        const descripcion  = `${this.consumible.categoria}${subcat}${marca}${modelo}`
        return descripcion 
      },

      getContent () {
        let text = ''
        if (this.consumible.salidas) {
          text = `${ this.consumible.salidas.length } ${ this.consumible.salidas.length == 1 ? 'Salida' : 'Salidas' } en ${ this.consumible.filter === 'CORP' ? 'Corporativo' : this.consumible.filter }`
        }
        return text
      },

      getTotal () {
        let totalCons = 0
        let html = ''
        if (this.consumible.salidas) {
          totalCons = this.consumible.salidas.reduce( ( sum, { cantidad_r } ) => sum + parseInt(cantidad_r) , 0)
        }

        if (totalCons > 1) {
          html = `<span class='tag is-black'>Total: ${totalCons}</span>`
        } else {
          html = ''
        }  
        return html
      },

      cerrarModal() {
        this.$emit('padre:close', 'close')
      }
    }
  }
</script>

<style lang="scss" scoped>
hr {
  margin: 3px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/shared/ModalConsumibles.vue